var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsDarkDown4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4853 26L19.364 35.1213C18.7474 35.7379 17.9292 36.03 17.1217 35.9976C17.0813 35.9992 17.0407 36 17 36H13C11.3431 36 10 34.6569 10 33C10 31.3431 11.3431 30 13 30H16L25.0662 20.9338C25.3233 20.6767 25.6154 20.4761 25.9272 20.3318C26.3386 20.1197 26.8053 20 27.3 20H31C32.6568 20 34 21.3431 34 23C34 24.6569 32.6568 26 31 26H28.4853Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15C24 13.8954 23.1046 13 22 13C20.8954 13 20 13.8954 20 15C20 16.1046 20.8954 17 22 17C23.1046 17 24 16.1046 24 15ZM24 19.25C24 18.5596 23.4404 18 22.75 18C20.6789 18 19 19.6789 19 21.75V25.5858L24 20.5858V19.25Z",
    fill: "white",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28C34.2652 28 34.5195 28.1053 34.707 28.2928C34.8945 28.4803 34.9998 28.7346 34.9998 28.9998C34.9998 29.265 34.8945 29.5193 34.707 29.7068L31.414 32.9998H33C33.2652 32.9998 33.5196 33.1051 33.7071 33.2927C33.8946 33.4802 34 33.7346 34 33.9998C34 34.265 33.8946 34.5194 33.7071 34.7069C33.5196 34.8944 33.2652 34.9998 33 34.9998H29C28.8689 34.9992 28.7391 34.973 28.618 34.9228C28.3731 34.8213 28.1785 34.6267 28.077 34.3818C28.0268 34.2607 28.0006 34.1309 28 33.9998V29.9998C28 29.7346 28.1054 29.4802 28.2929 29.2927C28.4804 29.1051 28.7348 28.9998 29 28.9998C29.2652 28.9998 29.5196 29.1051 29.7071 29.2927C29.8946 29.4802 30 29.7346 30 29.9998V31.5858L33.293 28.2928C33.4805 28.1053 33.7348 28 34 28Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsDarkDown4);
export default __webpack_public_path__ + "static/media/es-dark-down-4.cfe6172dba3970b856b91ac8d7f1f9a7.svg";
export { ForwardRef as ReactComponent };